import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const CERTIFICATETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CertificateType.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const CERTIFICATETYPE_CONFIG = {
  entityName: 'CertificateType',
  localizationKey: 'Planning::Entity.CertificateType',
  fields: CERTIFICATETYPE_FIELDS,
  permission: 'Planning.CertificateTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
